import { jsx as L, jsxs as t } from "react/jsx-runtime";
import "react";
var H = (l) => /* @__PURE__ */ t("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...l,
  children: [
    /* @__PURE__ */ L("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ L("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-52 -16)",
      fill: "white"
    }),
    /* @__PURE__ */ L("path", {
      d: "M20 0H0V19.9996H20V0Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M20 0H0V2.85732H20V0Z",
      fill: "#6DA544"
    }),
    /* @__PURE__ */ L("path", {
      d: "M20 5.71423H0V8.57112H20V5.71423Z",
      fill: "#6DA544"
    }),
    /* @__PURE__ */ L("path", {
      d: "M20 11.4285H0V14.2858H20V11.4285Z",
      fill: "#6DA544"
    }),
    /* @__PURE__ */ L("path", {
      d: "M20 17.1427H0V20H20V17.1427Z",
      fill: "#6DA544"
    }),
    /* @__PURE__ */ L("path", {
      d: "M10 0H0V8.5711H10V0Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ L("path", {
      d: "M4.38809 6.55461L3.98047 5.73943V4.10904L4.99949 3.29382L6.01848 4.10904V5.33183L6.42609 4.92422V5.73943L5.61086 6.55461H4.38809Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M2.19543 4.05463L2.30332 4.38681H2.65254L2.37004 4.59208L2.47801 4.92418L2.19543 4.71895L1.91285 4.92418L2.02082 4.59208L1.73828 4.38681H2.0875L2.19543 4.05463Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M3.0118 3.23944L3.11977 3.57158H3.46898L3.18641 3.77685L3.29437 4.10899L3.0118 3.90372L2.7293 4.10899L2.83719 3.77685L2.55469 3.57158H2.90391L3.0118 3.23944Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M3.82629 2.42426L3.93422 2.75644H4.28344L4.0009 2.9617L4.10883 3.29381L3.82629 3.08854L3.54371 3.29381L3.65168 2.9617L3.36914 2.75644H3.71832L3.82629 2.42426Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M7.80281 4.05463L7.69492 4.38681H7.3457L7.6282 4.59208L7.52027 4.92418L7.80281 4.71895L8.08535 4.92418L7.97742 4.59208L8.25996 4.38681H7.91078L7.80281 4.05463Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M6.9884 3.23944L6.88043 3.57158H6.53125L6.81379 3.77685L6.70582 4.10899L6.9884 3.90372L7.2709 4.10899L7.16301 3.77685L7.44551 3.57158H7.09629L6.9884 3.23944Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M6.17391 2.42426L6.06602 2.75644H5.7168L5.9993 2.9617L5.89141 3.29381L6.17391 3.08854L6.45645 3.29381L6.34852 2.9617L6.63105 2.75644H6.28188L6.17391 2.42426Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M5.00012 2.01666L4.89219 2.34884H4.54297L4.82551 2.55411L4.71758 2.88621L5.00012 2.68098L5.28262 2.88621L5.17473 2.55411L5.45723 2.34884H5.10805L5.00012 2.01666Z",
      fill: "#F0F0F0"
    })
  ]
});
export {
  H as default
};
